export const BLOCK_LIBRARY_MENU_ITEMS = {
  all: {
    icon: 'toy-brick',
    value: null,
  },
  root: {
    value: 'root',
  },
  tags: {
    icon: 'tag',
    value: 'tags',
  },
} as const
